module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "tips-mask",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.onCancel.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "tips-wrapper",
    class: {
      'tips-start': _vm.actionShow, 'tips-end': !_vm.actionShow
    }
  }, [_c('div', {
    staticClass: "tips-font"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tips-btns"
  }, [_c('wx-open-launch-weapp', {
    staticClass: "mini-btn-container",
    attrs: {
      "id": "launch-btn",
      "username": _vm.username,
      "path": _vm.path,
      "env-version": _vm.miniprogramEnv
    },
    on: {
      "launch": _vm.handleLaunchFn,
      "error": _vm.handleErrorFn,
      "ready": _vm.handlerReadyFn
    }
  }, [_c('script', {
    attrs: {
      "type": "text/wxtag-template"
    }
  }, [_vm._v("\n\t\t\t\t\t<style>\n\t\t\t\t\t\t.mini-btn {\n\t\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\t\tfont-size: 1.2em;\n\t\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\t\tpadding: .6em 0;\n\t\t\t\t\t\t\tbox-sizing: border-box;\n\t\t\t\t\t\t\tbackground-color: #fff;\n\t\t\t\t\t\t\tmargin-bottom: .5em;\n\t\t\t\t\t\t\tcolor: red;\n\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t}\n\t\t\t\t\t</style>\n\t\t\t\t\t<a class=\"mini-btn\">" + _vm._s(_vm.btns[0]) + "</a>\n\t\t\t\t")])]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.type !== 'alert'),
      expression: "type !== 'alert'"
    }],
    staticClass: "tips-two-btn",
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.btns[1]))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d09d31ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/lib/wind-ui/package/confirmSheetMini/Confirm-sheet-mini.vue
// module id = 621
// module chunks = 1